import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  // FeeApproveReject,
  // GetFeeApprovedList,
  allotRoom,
  pendingRoomAllotmentList,
  GetAvailableRoom,
  GetBedMasterById,
  GetClassMaster,
  GetFeeAppPendingList,
  GetRoomMaster,
  IMG_BASE_URL,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const PendingRoomAllotment = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  const [allotModalOpen, setAllotModalOpen] = useState(false)
  const [rooms, setRooms] = useState([])
  const [beds, setBeds] = useState([])
  const [selectedRoomId, setSelectedRoomId] = useState(null)
  const [selectedBedId, setSelectedBedId] = useState(null)
  // const [rejectModalOpen, setRejectModalOpen] = useState(false)
  // const [rejectReason, setRejectReason] = useState('')
  const [classes, setClasses] = useState([])
  const [selectedClassId, setSelectedClassId] = useState(null)
  console.log(pendingRoomAllotmentList);

  useEffect(() => {
    console.log("useEffect executed");
    fetchPendingRoomAllotmentList()
  }, [])

  const fetchClasses = async () => {
    try {
      const res = await axios.get(`${GetClassMaster}/${storedBranchId}`)
      setClasses(res.data)
    } catch (err) {
      toast.error('Failed to load classes')
    }
  }

  const fetchRooms = async (classId) => {
    try {
      const res = await axios.get(`${GetAvailableRoom}/${classId}`)

      if (Array.isArray(res.data)) {
        setRooms(res.data)
      } else {
        setRooms([]) // prevent crash
        if (res.data === 'NO_ROOMS_FOUND') {
          toast.warning('No rooms available for selected class')
        }
      }
    } catch (err) {
      toast.error('Failed to load rooms')
      setRooms([]) // safety
    }
  }

  const fetchBeds = async (roomId) => {
    try {
      const res = await axios.get(
        `${GetBedMasterById}/${storedBranchId}/${roomId}`,
      )
      setBeds(res.data)
    } catch (err) {
      toast.error('Failed to load beds')
    }
  }


   const fetchPendingRoomAllotmentList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${pendingRoomAllotmentList}/${storedBranchId}/${BoardingYear}`,
      )
      console.log(res.data);

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        hostel_tax_id: item.payment?.hostel_tax_id ?? '-',
        hostel_pay_amount: item.payment?.hostel_pay_amount ?? '-',

        // 👉 Correct date format (YYYY-MM-DD)
        hostel_pay_date: item.payment?.hostel_pay_date
          ? new Date(item.payment.hostel_pay_date).toISOString().split('T')[0]
          : '-',
        hostel_pay_mode:
          item.payment.hostel_pay_mode == 1
            ? 'Cash'
            : item.payment.hostel_pay_mode == 2
            ? 'UPI'
            : 'Online',
        full_data: item,
      }))

      console.log("Calling API...");
      console.log(`${pendingRoomAllotmentList}/${storedBranchId}/${BoardingYear}`);

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.hostel_tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    // { title: 'Tax ID', dataIndex: 'hostel_tax_id' },
    // { title: 'Amount', dataIndex: 'hostel_pay_amount' },
    { title: 'Pay Date', dataIndex: 'hostel_pay_date' },
    // { title: 'Pay Mode', dataIndex: 'hostel_pay_mode' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const handleApproval = async (type) => {
    if (!selectedRecord) return

    const today = new Date().toISOString().split('T')[0]
    const approvalValue = type === 'approve' ? 2 : 3

    const body = {
      reg_id: parseInt(selectedRecord.reg_id),
      branch_id: parseInt(selectedRecord.branch_id),
      class_id: parseInt(selectedClassId),

      // 👉 Use selected room/bed from allocation modal
      room_id: parseInt(selectedRoomId),
      bed_id: parseInt(selectedBedId),
      year: parseInt(BoardingYear),

      hostelPay_approval: approvalValue,
      ...(approvalValue === 2 && { hostelPay_approval_date: today }),
    }

    try {
      setLoading(true)
      const res = await axios.put(allotRoom, body)

      if (res.data === 'APPROVED') {
        toast.success(
          approvalValue === 2
            ? 'Application Approved Successfully'
            : 'Application Rejected Successfully',
        )
        setConfirmChecked(false)
        setAllotModalOpen(false)
        setSelectedRoomId(null)
        setSelectedBedId(null)
        fetchPendingRoomAllotmentList()
      } else if (res.data == 'ERROR') {
        toast.warn('Some error occurred! Please try again later')
      }
    } catch (err) {
      toast.error('Something went wrong!')
    } finally {
      setLoading(false)
    }
  }

  // const handleRejectSubmit = async () => {
  //   if (!selectedRecord) return

  //   const body = {
  //     reg_id: parseInt(selectedRecord.reg_id),
  //     hostelPay_approval: 3,
  //     reject_reason: rejectReason.trim(),
  //   }

  //   try {
  //     setLoading(true)
  //     const res = await axios.put(FeeApproveReject, body)

  //     toast.success('Application Rejected Successfully')

  //     // Reset all states
  //     setRejectModalOpen(false)
  //     setRejectReason('')
  //     setConfirmChecked(false)

  //     fetchPendingRoomAllotmentList()
  //   } catch (err) {
  //     toast.error('Failed to reject application')
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Full Name': item.full_name,
      'WhatsApp No': item.whats_no,
    //   'Tax ID': item.tax_id,
    //   'Amount' : item.hostel_pay_amount,
      'Pay Date': item.hostel_pay_date,
    //   'Pay Mode': item.hostel_pay_mode,
    }))
    
    
    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
    ]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Pending Room Allotment',
    )

    XLSX.writeFile(workbook, 'Pending_Room_Allotment_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Pending Room Allotment List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          setConfirmChecked(false)
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <h6 style={titleText}>- Personal Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                      alt="Profile Picture"
                      className="rounded-circle img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                          {selectedRecord.s_lname}
                        </span>
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/**-----------APPROVE/REJECT SECTION-----------------*/}

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
                <Button
                  className="addButton"
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => {
                    setViewModalOpen(false)
                    setAllotModalOpen(true)
                    setConfirmChecked(false)
                    fetchClasses()
                  }}
                >
                  Select Room
                </Button>

                <Button
                  danger
                  disabled={!confirmChecked}
                  // loading={loading}
                  onClick={() => {
                     setViewModalOpen(false)
                      setConfirmChecked(false)
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* =================== ROOM & BED ALLOT MODAL =================== */}
      <Modal
        className="custom-alloc-modal"
        title="Room & Bed Allotment"
        open={allotModalOpen}
        // onCancel={() => setAllotModalOpen(false)}
        onCancel={() => {
          setAllotModalOpen(false)
          setSelectedClassId(null)
          setSelectedRoomId(null)
          setSelectedBedId(null)
        }}
        width={900}
        footer={null}
      >
        <h5 className="section-title">Select Class</h5>
        <div className="row">
          {classes.map((cls) => {
            const isSelected = selectedClassId === cls.class_id

            return (
              <div className="col-md-3 mb-3" key={cls.class_id}>
                <div
                  className={`room-card ${isSelected ? 'room-selected' : ''}`}
                  onClick={() => {
                    setSelectedClassId(cls.class_id)
                    setSelectedRoomId(null)
                    setSelectedBedId(null)
                    fetchRooms(cls.class_id) // 👈 fetch rooms after class select
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <b>{cls.class_name}</b>
                </div>
              </div>
            )
          })}
        </div>

        {/* Rooms */}
        {selectedClassId && (
          <>
            <h5 className="section-title">Select Room</h5>
            <div className="row">
              {rooms.map((room) => {
                const isOccupied = room.status === 2
                const isSelected = selectedRoomId === room.room_id

                return (
                  <div className="col-md-3 mb-3" key={room.room_id}>
                    <div
                      className={`
                            room-card
                            ${isOccupied ? 'room-occupied' : ''}
                            ${isSelected ? 'room-selected' : ''}
                            `}
                      onClick={() => {
                        if (!isOccupied) {
                          setSelectedRoomId(room.room_id)
                          setSelectedBedId(null)
                          fetchBeds(room.room_id)
                        }
                      }}
                      style={{ cursor: isOccupied ? 'not-allowed' : 'pointer' }}
                    >
                      <b>{room.room_no}</b>
                      <br />
                      <br />
                      {isOccupied && <small>(Occupied)</small>}
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        )}

        {/* Beds */}
        {selectedRoomId && (
          <>
            <h5 className="section-title">Select Bed</h5>
            <div className="row">
              {beds.map((bed) => {
                const bedOccupied = bed.status === 2
                const bedSelected = selectedBedId === bed.bed_id

                return (
                  <div className="col-md-3 mb-3" key={bed.bed_id}>
                    <div
                      className={`
                                bed-card
                                ${bedOccupied ? 'bed-occupied' : ''}
                                ${bedSelected ? 'bed-selected' : ''}
                                `}
                      onClick={() => {
                        if (!bedOccupied) setSelectedBedId(bed.bed_id)
                      }}
                      style={{
                        cursor: bedOccupied ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <b>{bed.bed_no}</b>
                      <br />
                      {bedOccupied ? 'Occupied' : 'Available'}
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        )}

        {/* Button */}
        <div className="text-end mt-4">
          <Button
            className="addButton"
            disabled={!selectedClassId || !selectedRoomId || !selectedBedId}
            onClick={() => {
              setAllotModalOpen(false)
              handleApproval('approve')
            }}
          >
            Allot & Approve
          </Button>
        </div>

      </Modal>
    </div>
  )
}

export default PendingRoomAllotment
